import React from "react";

export default function ModalDeleteDocument({ onClose, data, onClickData }) {

    return (
        <div className="z-10 fixed flex top-0 right-0 w-full h-full justify-center items-center bg-[#0000008f]">
            {/* <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" /> */}
            <div className="w-[600px] bg-white rounded-md">
                <div className="flex justify-end mt-[10px] mr-[10px]">
                    <img className="w-7 h-7 cursor-pointer" onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default} alt="icon"></img>
                </div>
                <div className="-mt-5 p-7">
                    <div className='w-full text-2xl font-bold text-center'>
                        คุณต้องการลบเอกสารฉบับนี้ใช่หรือไม่
                    </div>
                    <div className='text-center text-base font-bold pb-5 pt-5'>
                        <div>{data.document_name}</div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', gridGap: 20 }}>
                        <button
                            onClick={() => { onClickData(data) }}
                            className="px-5 py-2 text-white bg-blue-500 rounded-md">
                            ลบ
                        </button>
                        <button
                            onClick={() => { onClose() }}
                            className="px-5 py-2 text-blue-500 bg-white rounded-md border-blue-500 border">
                            ยกเลิก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}